import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { Dayjs } from 'dayjs';

import { BlurredAztecCode } from '../../../atoms/BlurredAztecCode/BlurredAztecCode';
import { MplTicketValidity } from '../../MplTicketValidity';

import {
	MplDeutschlandTicketCardFooter,
	MplDeutschlandTicketCardHeader,
	MplDeutschlandTicketCardSeparator,
	MplDeutschlandTicketNameAndStatus,
	StyledBottomContainer,
	StyledCardContainer,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

interface IMplDeutschlandTicketCardPausedProps {
	firstName: string;
	lastName: string;
	formattedPrice: string;
	ticketId?: string;
	validFrom: Dayjs;
	validUntil: Dayjs;
}

export const MplDeutschlandTicketCardPaused: FC<
	IMplDeutschlandTicketCardPausedProps
> = ({
	firstName,
	lastName,
	formattedPrice,
	ticketId,
	validFrom,
	validUntil,
}) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<MplDeutschlandTicketCardHeader formattedPrice={formattedPrice} />
				<MplDeutschlandTicketCardSeparator />
				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<MplDeutschlandTicketNameAndStatus
							firstName={firstName}
							lastName={lastName}
							statusText={t('dticket_large.status.paused')}
							statusVariant="info"
						/>
						<MplTicketValidity
							validityLabel={t('dticket_large.validity_paused')}
							validFrom={validFrom}
							validUntil={validUntil}
						/>
					</StyledTicketDetailsSection>
					<BlurredAztecCode paused={true} />
					<MplDeutschlandTicketCardFooter ticketId={ticketId} />
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
